<h1>Dealer Status Page - @if (!subscribed) {
  <span class="name">Not</span>
} Enrolled</h1>

@if (subscribed && !loading) {
  @if (international) {
    <section>
      <h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is enrolled!</h2>
      <p>You are currently enrolled in the Ford Diagnostics Subscription. This gives all dealership employees access to IDS, FDRS, and Ford DiagNow. For more information or Frequently Asked Questions (FAQs) please navigate to the following – <a href="/faq">Diagnostic Subscription FAQs</a>.
      <ul>
        <li>PA Code: {{sub.siteCode}}
        <li>Number of Service Technicians: {{sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}
        <li>Yearly Cost Per Technician: ${{prices.per_tech.toLocaleString(undefined, {minimumFractionDigits: 2})}}
        <li>Monthly Total Cost: ${{prices.monthly.toLocaleString(undefined, {minimumFractionDigits: 2})}}
        <li>Each Technician may be logged into {{sub.concurrentSessions.toLocaleString()}} instances of software at one time.
        <li>Total allowable active sessions in your dealership is {{(sub.maxAllowedUniqueDealerTechnicianLogins * sub.concurrentSessions).toLocaleString()}}.
      </ul>
      <p><button [routerLink]="['/request-intl']">Request more technicians</button>
    </section>
  } @else {
    <section>
      <h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is enrolled!</h2>
      <p>You are currently enrolled in the Ford Diagnostics Subscription. This gives all dealership employees access to IDS, FDRS, and Ford DiagNow. For more information or Frequently Asked Questions (FAQs) please navigate to the following – <a href="/faq">Diagnostic Subscription FAQs</a>.
      <ul>
        <li>PA Code: {{sub.siteCode}}
        <li>Number of Service Technicians: {{sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}
        <li>Enrolled On: {{dateFormat(sub.startDate)}}
        <li>Yearly Cost Per Technician: ${{prices.per_tech.toLocaleString(undefined, {minimumFractionDigits: 2})}}
        <li>Monthly Total Cost: ${{prices.monthly.toLocaleString(undefined, {minimumFractionDigits: 2})}}
        <li>Each Technician may be logged into {{sub.concurrentSessions.toLocaleString()}} instances of software at one time.
        <li>Total allowable active sessions in your dealership is {{(sub.maxAllowedUniqueDealerTechnicianLogins * sub.concurrentSessions).toLocaleString()}}.
      </ul>
      <p><button [routerLink]="['/cancel']">Cancel Subscription</button>
    </section>
  }
}

@if (!subscribed  && !loading) {
  <section>
    <p>{{dealer.name}} <code>{{dealer.pa_code}}</code> is not currently enrolled in Ford Diagnostics Subscription. You will be unable to access IDS, FDRS, or Ford DiagNow until you enroll.
    <p>By clicking “Enroll Now” below, you agree to the <a href="/tos">Terms of Sale</a> and will subscribe to the Ford Diagnostics Subscription.</p>
    <ul>
      <li>PA Code: {{sub.siteCode}}
      <li>Number of Service Technicians: {{sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}
      <li>Expired On: {{dateFormat(sub.expiresAt)}}
      <li>Yearly Cost Per Technician: ${{prices.per_tech.toLocaleString(undefined, {minimumFractionDigits: 2})}}
      <li>Monthly Total Cost: ${{prices.monthly.toLocaleString(undefined, {minimumFractionDigits: 2})}}
      <li>Each Technician may be logged into {{sub.concurrentSessions.toLocaleString()}} instances of software at one time.
      <li>Total allowable active sessions in your dealership is {{(tech_count * sub.concurrentSessions).toLocaleString()}}.
    </ul>
    <p><button [routerLink]="['/enroll']">Enroll Now</button>
  </section>
}

@if (sub.status && sub.status != 404) {
  <section>
    <p><img src="./assets/loader.gif"> Retrieving enrollment status</p>
    <p><button (click)="retry()">Retry</button>
  </section>
}
